<template>
  <div>
    <div class="content-bottom-padded">
    <el-alert
            type="info"
            title="设置小程序相关新信息！新增的服务器配置信息需要先在开放平台填写后再更新到指定小程序上"
            show-icon
    ></el-alert>

      <el-select v-model="check_wxappid" @change="wxappSelectHandle" placeholder="选择小程序"
                 style="width: 50%;">
        <el-option
                v-for="(item, index) in wx_appid_list"
                :key="index"
                :label="item.name"
                :value="item.value">
        </el-option>
      </el-select>
    </div>
    <el-col :span="3" class="content-right">
      <el-button type="primary" icon="plus" @click="handlefindList">查看服务器设置</el-button>
    </el-col>

    <el-dialog title="查看服务器设置" :visible.sync="dialog" :close-on-click-modal="false">
      <el-form v-model="getlist" label-width="160px">
        <el-form-item label="requestdomain">
            <el-input type="textarea" v-model="getlist.requestdomain"  placeholder="requestdomain"></el-input>
        </el-form-item>
        <el-button type="primary" icon="plus" @click="editHandle('request')"> 更新requestdomain </el-button>
        <el-form-item label="wsrequestdomain">
          <el-input type="textarea" v-model="getlist.wsrequestdomain"  placeholder="wsrequestdomain"></el-input>
        </el-form-item>
        <el-button type="primary" icon="plus" @click="editHandle('socket')"> 更新wsrequestdomain </el-button>
        <el-form-item label="uploaddomain">
          <el-input type="textarea" v-model="getlist.uploaddomain"  placeholder="uploaddomain"></el-input>
        </el-form-item>
        <el-button type="primary" icon="plus" @click="editHandle('uploadFile')"> 更新uploaddomain </el-button>
        <el-form-item label="downloaddomain">
          <el-input type="textarea" v-model="getlist.downloaddomain"  placeholder="downloaddomain"></el-input>
        </el-form-item>
        <el-button type="primary" icon="plus" @click="editHandle('downloadFile')"> 更新downloaddomain </el-button>
        <el-form-item label="invalid_requestdomain">
          <el-input type="textarea" v-model="getlist.invalid_requestdomain"  placeholder="invalid_requestdomain"></el-input>
        </el-form-item>
        <el-form-item label="invalid_wsrequestdomain">
          <el-input type="textarea" v-model="getlist.invalid_wsrequestdomain"  placeholder="invalid_wsrequestdomain"></el-input>
        </el-form-item>
        <el-form-item label="invalid_uploaddomain">
            <el-input type="textarea" v-model="getlist.invalid_uploaddomain"  placeholder="invalid_uploaddomain"></el-input>
        </el-form-item>
        <el-form-item label="invalid_uploaddomain">
          <el-input type="textarea" v-model="getlist.invalid_downloaddomain"  placeholder="invalid_downloaddomain"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>

    <router-view></router-view>
  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import timeChoose from '../../components/timechoose'
    import { getWxaAuthList,getWxaModifyDomain } from '../../api/wxa'

    export default {
        components: {
            timeChoose
        },
        data () {
            return {
                dialog:false,
                formLabelWidth: '120px',
                loading: false,
                check_wxappid:'',
                wx_appid_list:[
                    {name:'商城小程序e1b0',value:'wx47d38fb07875e1b0'},
                    {name:'多店铺商城小程序7ef2',value:'wx97aa332d3dea7ef2'}
                ],
                dialogVisibleMonitors: false,
                dialogVisibleSources: false,
                wx_content:'',
                getlist:[],
                params:{
                    action:'',
                    modifyDomain:'',
                    wxaAppId:'',
                    request_type:'',
                },

                monitorsList: [],
                wxaList: [],
                weappPagesList: [],
                sourceList: [],
                selectSourceList: []
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            wxappSelectHandle () {
                // this.check_wxappid = this.check_wxappid
                this.params.wxaAppId = this.check_wxappid
            },

            handlefindList: function () {
                this.dialog = true
                this.getModifiDomain()
            },
            getModifiDomain:function () {
                this.params.action = 'get';
                this.params.request_type = 'get';

                getWxaModifyDomain(this.params).then(response => {
                    if(response.data.data.res.errmsg = 'ok') {
                        this.getlist = response.data.data.res;
                    }
                    // this.getlist = response.data.res;
                    // alert(response.data.data.res.errmsg);
                    this.loading = false
                })
            },
            editHandle:function(request_type) {

                this.$confirm('是否更新, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    this.params.action = 'add'
                    this.params.request_type = request_type
                    if(request_type=='request'){
                        this.params.modifyDomain = this.getlist.requestdomain
                    }else if (request_type=='socket'){
                        this.params.modifyDomain = this.getlist.wsrequestdomain
                    }else if(request_type=='uploadFile'){
                        this.params.modifyDomain = this.getlist.uploaddomain
                    }else if(request_type=='downloadFile'){
                        this.params.modifyDomain = this.getlist.downloaddomain
                    }else{
                        this.params.modifyDomain = ''
                    }
                    getWxaModifyDomain(this.params).then(response => {

                        if(response.data.data.res.errmsg = 'ok') {
                          this.getModifiDomain()
                        }
                    })
                }).catch(() => {
                    this.params.action = ''
                    this.params.request_type = ''
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })

            }

        },
        mounted () {

        }
    }
</script>
<style scoped lang="scss">
  .refresh {
    color: #38f;
    cursor: pointer;
  }
  .el-button a { color: #fff; }
  .el-transfer {
    text-align: center;
    padding: 10px 0 20px;
  }
</style>
<style type="text/css" lang="scss">
  .sources-dialog {
    .el-transfer-panel {
      text-align: left;
      width: 270px;
      .el-transfer-panel__body.is-with-footer {
        box-sizing: content-box;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// setting_domain.vue?65ec57a6